export default __webpack_public_path__ + "static/media/COL.e8ea15f8.jpg";